<template>
	<div>
		<div class="row justify-content-center">
			<div class="col-md-6 mt-4">
				<LoginForm />
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-md-6">
				<h3>Not a member?</h3>
				<p>The PEI (Point Enterprises, Inc.) Client Access site lets members access their applications and manage their organization. To create your organization or join an existing one, please <router-link to="/signup">Signup</router-link>.</p>
				<p>
					<a href="https://www.pointent.com/staffpro/" alt="StaffPro Branch Resource Management" target="_blank" class="btn btn-primary">Learn more about StaffPro Branch Resource Management</a>
				</p>
			</div>
		</div>
	</div>
</template>
<script>
import LoginForm from '@/components/LoginForm.vue'

export default {
  name: 'LandingPage',
  components: {
    LoginForm
  }
}

</script>
